import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';
import { useAuth } from './auth';

const FavCtx = createContext(null);

export const FavoritesProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user || user.role !== 'buyer') { setIds(new Set()); return; }
    try {
      const { data } = await api.get('/favorites');
      setIds(new Set(data.product_ids || []));
    } catch { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (product_id) => {
    if (!user) return false;
    if (ids.has(product_id)) {
      await api.delete(`/favorites/${product_id}`);
      setIds((s) => { const n = new Set(s); n.delete(product_id); return n; });
      return false;
    }
    await api.post('/favorites', { product_id });
    setIds((s) => new Set(s).add(product_id));
    return true;
  };

  return (
    <FavCtx.Provider value={{ ids, toggle, refresh, isFav: (id) => ids.has(id) }}>
      {children}
    </FavCtx.Provider>
  );
};

export const useFavorites = () => useContext(FavCtx);
